export { default, getStaticPaths, getStaticProps } from '../../src/pages/Guide'
